import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { hornavbarSearchAnimations } from '../../../../util/animations/hornavbar-search-animations';
import { CompanySearchDto } from '../../../../domain/recovery/component/recovery-company/dto/CompanyWithOrgDto';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-hornavbar-company-search',
  templateUrl: './hor-nav-bar-company-search.component.html',
  styleUrls: ['./hor-nav-bar-company-search.component.scss'],
  animations: [hornavbarSearchAnimations],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorNavBarCompanySearchComponent implements OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();
  isSearchActive = false;
  searchTerm = '';
  @Output() selectedCompanyEmitter = new EventEmitter<CompanySearchDto>();

  selectCompany(company: CompanySearchDto): void {
    this.selectedCompanyEmitter.emit(company);
    this.isSearchActive = false;
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

}
